module.exports = {
    sentryEnabled: true,
    recaptchaSiteKey: "6Ld0coQrAAAAABxZ0JkfiQZc1w5epJ8e7auFZm-c",
    coreApi: {
        protocol: 'https',
        host: 'api-qa-gcp.ct-production.net'
    },
    posthog: {
        key: 'phc_qw80Nr10bni7uTjPKscnohSDsYwR8aVHjV0Q7qaOgXo',
        host: 'https://app.posthog.com'
    }
};
